(function() {
    angular.module('emarket.commons').directive('emMap', function() {
      //do the map logic
        var directive = {
            scope: {
                ngModel: '=',
                onChange: '&',
                onError: '&?',
                searchable: '=',
                resize: '=',
                marker: '='
            },
            templateUrl: 'directives/map/em.map.tpl.html',
            controller: 'EmMapController as vm',
            link: function(scope, element) {

                element.addClass('em-map__container');
            }
        };
        return directive;
    });
}());
